import { MdcChipColors } from 'ids-wc/dist/types/components';

export interface IRISPaymentHistoryItem {
  amount: string;
  debtorNo: string;
  institution: Institution;
  message: string;
  paymentDate: string;
  status: IRISPaymentStatus;
  rfcode: string;
  type: 'keao' | 'currentContributions';
}

export interface Institution {
  description: string;
  code: string;
}

// S - Success, C - Cancelled, P - Pending, O - Other
export type IRISPaymentStatus = 'S' | 'C' | 'P' | 'O';

export interface IRISPaginationMeta {
  pageSize: number;
  page: number;
  total: number;
}

export interface IRISPaymentInitDTO {
  partyRoleId: number;
  debtorNo: string;
  paymentCode: string;
  amountInCents: string;
  institution: {
    description: string;
  };
}

export const ChipStatusColors: Record<IRISPaymentStatus, MdcChipColors> = {
  S: 'success',
  C: 'warning',
  P: 'surface',
  O: 'surface'
};
